import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const getReconcilation = createAsyncThunk(
  "app/getReconcilation",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/report/farmer-reconcile/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const exportReconcilation = async ({ filters }) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(`/api/download/farmer-reconcile/filter`, body, config);
    return res.data;
  } catch (err) {
    throw err;
  }
};